var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pa-10"},[_c('title-page',{attrs:{"icon":"ico-carplug"}},[_vm._v(" "+_vm._s(_vm.$t('rfid.search-a-rfid'))+" ")]),_c('tokens-manager')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }